"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBFSection1Data = exports.GetBFSection3Data = exports.GetBFSection2Data = exports.GetBFSection4Data = exports.GetBFSection1Data = exports.GetBFAllPatients = exports.AddSection4PatientData = exports.AddBFPatientSectionData = exports.AddPatientProvider = void 0;
const axios_1 = require("axios");
const react_query_1 = require("react-query");
const CredentialStore_1 = require("../../stores/CredentialStore");
const Utils_1 = require("../../utils/Utils");
exports.AddPatientProvider = () => {
    // const docId = credentialStore((state) => state.docId);
    const jwt = CredentialStore_1.credentialStore((state) => state.token);
    return react_query_1.useMutation((data) => axios_1.default.post(`${Utils_1.APIURL}/api/fungus/post/addPatient`, Object.assign({}, data), {
        headers: {
            'auth-token': jwt,
        },
    }));
};
exports.AddBFPatientSectionData = () => {
    const jwt = CredentialStore_1.credentialStore((state) => state.token);
    return react_query_1.useMutation((data) => axios_1.default.post(`${Utils_1.APIURL}/api/fungus/post/section/${data.mongoId}`, Object.assign({}, data.data), {
        headers: {
            'auth-token': jwt,
        },
    }));
};
exports.AddSection4PatientData = () => {
    const jwt = CredentialStore_1.credentialStore((state) => state.token);
    return react_query_1.useMutation((data) => axios_1.default.post(`${Utils_1.APIURL}/api/fungus/post/section4/${data.mongoId}`, {
        surgicalPlan: data.surgicalPlan,
    }, {
        headers: {
            'auth-token': jwt,
        },
    }));
};
exports.GetBFAllPatients = () => {
    const docId = CredentialStore_1.credentialStore((state) => state.docId);
    const jwt = CredentialStore_1.credentialStore((state) => state.token);
    return react_query_1.useQuery(`get All Patients for ${docId}`, () => axios_1.default.get(`${Utils_1.APIURL}/api/fungus/get/getPatients`, {
        headers: {
            'auth-token': jwt,
        },
    }), {
        staleTime: 120000,
        refetchOnWindowFocus: false,
        retry: 1,
    });
};
exports.GetBFSection1Data = (patientId) => {
    const jwt = CredentialStore_1.credentialStore((state) => state.token);
    return react_query_1.useQuery([`get All section 1 BF data`, patientId], () => axios_1.default.get(`${Utils_1.APIURL}/api/fungus/get/section1/${patientId}`, {
        headers: {
            'auth-token': jwt,
        },
    }), {
        enabled: !!patientId,
        refetchOnWindowFocus: false,
        staleTime: 1200000,
        retry: 1,
    });
};
exports.GetBFSection4Data = (patientId) => {
    const jwt = CredentialStore_1.credentialStore((state) => state.token);
    return react_query_1.useQuery([`get All section 4 BF data`, patientId], () => axios_1.default.get(`${Utils_1.APIURL}/api/fungus/get/section4/${patientId}`, {
        headers: {
            'auth-token': jwt,
        },
    }), {
        enabled: !!patientId,
        refetchOnWindowFocus: false,
        staleTime: 1200000,
        retry: 1,
    });
};
exports.GetBFSection2Data = (patientId) => {
    const jwt = CredentialStore_1.credentialStore((state) => state.token);
    return react_query_1.useQuery([`get All section 2 BF data`, patientId], () => axios_1.default.get(`${Utils_1.APIURL}/api/fungus/get/section2/${patientId}`, {
        headers: {
            'auth-token': jwt,
        },
    }), {
        enabled: !!patientId,
        refetchOnWindowFocus: false,
        staleTime: 1200000,
        retry: 1,
    });
};
exports.GetBFSection3Data = (patientId) => {
    const jwt = CredentialStore_1.credentialStore((state) => state.token);
    return react_query_1.useQuery([`get All section 3 BF data`, patientId], () => axios_1.default.get(`${Utils_1.APIURL}/api/fungus/get/section3/${patientId}`, {
        headers: {
            'auth-token': jwt,
        },
    }), {
        enabled: !!patientId,
        refetchOnWindowFocus: false,
        staleTime: 1200000,
        retry: 1,
    });
};
exports.DeleteBFSection1Data = () => {
    const docId = CredentialStore_1.credentialStore((state) => state.docId);
    const jwt = CredentialStore_1.credentialStore((state) => state.token);
    return react_query_1.useMutation((data) => {
        return axios_1.default.delete(`${Utils_1.APIURL}/api/fungus/delete/patient/${docId}/${data.mongoid}`, {
            headers: {
                'auth-token': jwt,
            },
        });
    });
};
// export const UpdateBFSection1Data = () => {
// 	const docId = credentialStore((state) => state.docId);
// 	return useMutation((data: Record<string, any>) =>
// 		axios.patch(
// 			`${APIURL}/api/fungus/patch/section1/${docId}/${data.mongoId}`,
// 			{
// 				...data.data,
// 			}
// 		)
// 	);
// };
//# sourceMappingURL=BFSection1Provider.js.map